import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	filterByLabel: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.filters.user-filter.trigger-button.filter-by-label',
		defaultMessage: 'Last modified by',
		description: 'Label for the dropdown that filters the changes list by last modified user.',
	},
});
